import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import CaseImage from "@/components/CaseImage";
import { getCasePhotoUrls } from "@/lib/api";
import { getAnimalTypeLabel } from "@/lib/animalTypes";
import { timeAtSanctuaryLabel } from "@/lib/dateUtils";

export default function SanctuaryResidentCard({ caseItem }) {
  const cover = getCasePhotoUrls(caseItem)[0];
  const story = caseItem.sanctuary_story || caseItem.public_story || caseItem.case_history;
  const hasCareCost = (caseItem.monthly_care_cost || 0) > 0;
  const canSponsor = hasCareCost && caseItem.sponsor_razorpay_link;

  return (
    <div
      data-testid={`sanctuary-card-${caseItem.slug}`}
      className="bg-amtm-surface border border-amtm-border rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:scale-[1.02] flex flex-col"
    >
      <Link to={`/case/${caseItem.slug}`} className="block h-56 w-full overflow-hidden bg-amtm-give/30">
        <CaseImage src={cover} alt={caseItem.animal_name} animalType={caseItem.animal_type} className="w-full h-full object-cover" />
      </Link>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div>
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-display text-2xl text-amtm-text">{caseItem.animal_name}</h3>
            <div className="flex items-center gap-1.5 shrink-0">
              {caseItem.is_sponsored && (
                <span
                  className="text-xs font-semibold bg-amtm-success/15 text-amtm-success px-2.5 py-1 rounded-full"
                  data-testid={`sponsored-badge-${caseItem.slug}`}
                >
                  Sponsored ❤
                </span>
              )}
              <span className="text-xs font-semibold bg-amtm-info/15 text-amtm-info px-2.5 py-1 rounded-full">{getAnimalTypeLabel(caseItem)}</span>
            </div>
          </div>
          <p className="text-sm text-amtm-textMuted mt-1 line-clamp-2">{story}</p>
        </div>

        <p className="text-xs text-amtm-textMuted">{timeAtSanctuaryLabel(caseItem.arrival_at_sanctuary_date)}</p>

        {hasCareCost && (
          <p className="text-sm font-semibold text-amtm-text" data-testid={`sanctuary-care-cost-${caseItem.slug}`}>
            ₹{caseItem.monthly_care_cost.toLocaleString("en-IN")}/month to care for {caseItem.animal_name}
          </p>
        )}

        {canSponsor ? (
          <Button asChild className="w-full rounded-full bg-amtm-give text-amtm-giveText hover:bg-amtm-giveHover mt-1" data-testid={`sponsor-button-${caseItem.slug}`}>
            <a href={caseItem.sponsor_razorpay_link} target="_blank" rel="noopener noreferrer">
              <Heart className="h-4 w-4 mr-1.5" /> Sponsor {caseItem.animal_name} ❤
            </a>
          </Button>
        ) : (
          <Button asChild variant="outline" className="w-full rounded-full border-amtm-give text-amtm-giveText hover:bg-amtm-give/10 mt-1" data-testid={`meet-button-${caseItem.slug}`}>
            <Link to={`/case/${caseItem.slug}`}>Meet {caseItem.animal_name}</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
